export enum AppointmentStatusConstants {
    WAITING = 'waiting',
    IN_PROGRESS = 'in progress',
    FINISHED = 'finished',
    NO_SHOW_UP = 'no_show_up',
}
